import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface RequestRmaBillingInformationStyles {
    titleText?: TypographyProps;
    billingInformationTitleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
}

export const requestRmaBillingInformationStyles: RequestRmaBillingInformationStyles = {
    titleText: {
        as: "h2",
        variant: "h6",
        css: css`
            margin-bottom: 5px;
        `,
    },
    billingInformationTitleText: {
        as: "h2",
        variant: "h5",
        css: css`
            margin-bottom: 10px;
        `,
    },
};

/**
 * @deprecated Use requestRmaBillingInformationStyles instead.
 */
export const statusStyles = requestRmaBillingInformationStyles;
const styles = requestRmaBillingInformationStyles;

const RequestRmaBillingInformation: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    return (
        <>
            <Typography {...styles.titleText}>{translate("Billing Address")}</Typography>
            <AddressInfoDisplay
                companyName={order.btCompanyName}
                address1={order.btAddress1}
                address2={order.btAddress2}
                city={order.billToCity}
                state={order.billToState}
                postalCode={order.billToPostalCode}
                country={order.btCountry}
                extendedStyles={styles.addressDisplay}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: RequestRmaBillingInformation,
    definition: {
        allowedContexts: ["RequestRmaPage"],
        group: "Return Request (RMA)",
        fieldDefinitions: [],
    },
};

export default widgetModule;
